export default __webpack_public_path__ + "static/media/icon-free.3062eb2c.svg";